import { useState, useEffect } from 'react';
import { Cookie, X, Check } from 'lucide-react';
import './CookieBanner.css';

export const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà fait un choix
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Attendre un peu avant d'afficher le bandeau
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      essential: true,
      analytics: true,
      marketing: true,
      date: new Date().toISOString()
    }));
    setIsVisible(false);
  };

  const acceptEssential = () => {
    localStorage.setItem('cookie_consent', JSON.stringify({
      essential: true,
      analytics: false,
      marketing: false,
      date: new Date().toISOString()
    }));
    setIsVisible(false);
  };

  const savePreferences = (e) => {
    e.preventDefault();
    const form = e.target;
    localStorage.setItem('cookie_consent', JSON.stringify({
      essential: true,
      analytics: form.analytics.checked,
      marketing: form.marketing.checked,
      date: new Date().toISOString()
    }));
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner-overlay">
      <div className="cookie-banner">
        <div className="cookie-banner-header">
          <div className="cookie-icon">
            <Cookie size={24} />
          </div>
          <h3>Gestion des cookies</h3>
        </div>

        {!showDetails ? (
          <>
            <p className="cookie-text">
              Nous utilisons des cookies pour améliorer votre expérience sur notre site. 
              Les cookies essentiels sont nécessaires au fonctionnement du site. 
              Vous pouvez accepter tous les cookies ou personnaliser vos préférences.
            </p>
            
            <div className="cookie-buttons">
              <button 
                className="cookie-btn cookie-btn-secondary"
                onClick={acceptEssential}
              >
                Refuser
              </button>
              <button 
                className="cookie-btn cookie-btn-outline"
                onClick={() => setShowDetails(true)}
              >
                Personnaliser
              </button>
              <button 
                className="cookie-btn cookie-btn-primary"
                onClick={acceptAll}
              >
                <Check size={16} />
                Tout accepter
              </button>
            </div>
            
            <a href="/politique-de-confidentialite" className="cookie-link">
              En savoir plus sur notre politique de confidentialité
            </a>
          </>
        ) : (
          <form onSubmit={savePreferences} className="cookie-details">
            <div className="cookie-option">
              <div className="cookie-option-header">
                <label className="cookie-checkbox-label">
                  <input 
                    type="checkbox" 
                    checked 
                    disabled 
                    className="cookie-checkbox"
                  />
                  <span className="cookie-option-title">Cookies essentiels</span>
                </label>
                <span className="cookie-badge">Requis</span>
              </div>
              <p className="cookie-option-desc">
                Nécessaires au fonctionnement du site (session, sécurité).
              </p>
            </div>

            <div className="cookie-option">
              <div className="cookie-option-header">
                <label className="cookie-checkbox-label">
                  <input 
                    type="checkbox" 
                    name="analytics"
                    defaultChecked
                    className="cookie-checkbox"
                  />
                  <span className="cookie-option-title">Cookies analytiques</span>
                </label>
              </div>
              <p className="cookie-option-desc">
                Nous aident à comprendre comment vous utilisez le site.
              </p>
            </div>

            <div className="cookie-option">
              <div className="cookie-option-header">
                <label className="cookie-checkbox-label">
                  <input 
                    type="checkbox" 
                    name="marketing"
                    className="cookie-checkbox"
                  />
                  <span className="cookie-option-title">Cookies marketing</span>
                </label>
              </div>
              <p className="cookie-option-desc">
                Permettent d'afficher des publicités pertinentes.
              </p>
            </div>

            <div className="cookie-buttons">
              <button 
                type="button"
                className="cookie-btn cookie-btn-secondary"
                onClick={() => setShowDetails(false)}
              >
                Retour
              </button>
              <button 
                type="submit"
                className="cookie-btn cookie-btn-primary"
              >
                <Check size={16} />
                Enregistrer mes choix
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};
